import { PostCampaignStatus } from '../model/types';

export const postCampaignStatusLabel = {
  [PostCampaignStatus.APPLY_SUCCESS]: '신청완료',
  [PostCampaignStatus.SUBMITTED]: '제출완료',
  [PostCampaignStatus.DEVIATION]: '삭제차감',
  [PostCampaignStatus.NOT_SUBMITTED]: '미제출차감',
  [PostCampaignStatus.EARNING_SUCCESS]: '적립완료',
  [PostCampaignStatus.REJECT]: '반려차감',
  [PostCampaignStatus.DEDUCT]: '차감',
} as const;

export const postCampaignStatusBadgeColor = {
  [PostCampaignStatus.APPLY_SUCCESS]: 'gray',
  [PostCampaignStatus.SUBMITTED]: 'blue',
  [PostCampaignStatus.EARNING_SUCCESS]: 'blue',
  [PostCampaignStatus.DEVIATION]: 'danger',
  [PostCampaignStatus.NOT_SUBMITTED]: 'danger',
  [PostCampaignStatus.REJECT]: 'danger',
} as const;
